/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
} from "reactstrap";
import { GetAuthUser, loginApi } from "services/AuthService";
import { getEmpleadoById } from "services/EmpleadosService";
import { useHistory } from "react-router";
import LoadingComponent from "pages/components/Loading";
import {warningAlert} from "../components/SweetAlert"


function Login() {
  const [focusedUser, setfocusedUser] = useState(false);
  const [focusedPassword, setfocusedPassword] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [LoadingState, setLoadingState] = useState(false);
  const [alertSweet, setAlert] = useState(null);


  const history = useHistory ();

  const keyDownFunction =(event) => {
    if (event.keyCode === 13) {
      logear();
    }
  }

  const validacion = (user) => {
    let dev = true;
    if(!(user.usuario)){
      dev=false;
    }
    if((!user.password)){
      dev=false;
    }
    return dev;
  }

  const logear = async () => {
    setLoadingState(true)
    let user ={
      usuario: usuario,
      password: contrasena
    }
    if(validacion(user)){
      let estado = await loginApi(user);
      if(!estado){
        setLoadingState(false)
        warningAlert(setAlert, "Atencion!", "Usuario y/o contraseña incorrecto")
      }else{
        const authUser = await GetAuthUser();
        let displayName = authUser?.usuario?.usuario || user.usuario;

        if (authUser?.usuario?.empleadoId) {
          const empleado = await getEmpleadoById(authUser.usuario.empleadoId);
          if (empleado?.nombre || empleado?.apellido) {
            displayName = `${empleado.nombre || ''} ${empleado.apellido || ''}`.trim();
          }
        }

        localStorage.setItem('authDisplayName', displayName);
        sessionStorage.setItem('showHomeWelcome', '1');
        setLoadingState(false)
        history.replace('/admin/home');
      } 
    } else {
      setLoadingState(false)
      warningAlert(setAlert, "Atencion!", "Debe ingresar un usuario y una contraseña")
    }
  };

  const cambiarUsuario = event => {
    setUsuario(event.target.value);
  };

  const cambiarContrasena = event => {
    setContrasena(event.target.value);
  };

  return (
    <>
      {alertSweet}
      <LoadingComponent Visible={LoadingState}/>
      <Container fluid className="login-screen">
        <div className="login-card-shell">
          <Card className="border-0 mb-0 login-brand-card">
            <CardHeader className="bg-transparent pb-2 border-0 login-brand-card__header">
              <div className="login-brand-mark">
                <img
                  alt="GlobalNet"
                  src={require("assets/img/logo-Global-Net4.png").default}
                  className="login-brand-mark__img"
                />
              </div>
              <div className="login-brand-copy">
                <span className="login-brand-copy__eyebrow">Portal interno</span>
                <h2>Iniciar sesión</h2>
                <p>Accede a tus módulos habilitados y continúa con la operación.</p>
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-4">
              <Form role="form" onKeyDown={(e)=>keyDownFunction(e)}>
                <FormGroup
                  className={classnames("mb-3", {
                    focused: focusedUser,
                  })}
                >
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-user-tie"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Usuario"
                      type="text"
                      value={usuario}
                      onChange={cambiarUsuario}
                      onFocus={() => setfocusedUser(true)}
                      onBlur={() => setfocusedUser(false)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup
                  className={classnames({
                    focused: focusedPassword,
                  })}
                >
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Contraseña"
                      type="password"
                      value={contrasena}
                      onFocus={() => setfocusedPassword(true)}
                      onBlur={() => setfocusedPassword(false)}
                      onChange={cambiarContrasena}
                    />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button className="my-3 login-brand-button" color="info" type="button" onClick={()=>{logear()}}>
                    Iniciar Sesion
                  </Button>
                </div>
                <p className="login-brand-footnote">Uso exclusivo de personal autorizado.</p>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Container>
    </>
  );
}

export default Login;
